export default __webpack_public_path__ + "static/media/bnr3.918993fd.jpg";